import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function MachinesSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.Machines}/>;
}
